var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-flex',{class:['text-center', _vm.light? 'white--text' : 'primary--text'],attrs:{"xs12":""}},[_vm._v(_vm._s(_vm.loadingText)+"...")]),_c('v-flex',{staticClass:"mt-2 text-center",attrs:{"xs12":""}},[_c('v-progress-linear',{attrs:{"color":_vm.loadingColor,"indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }